export default Object.freeze({
  VIEW_ALL_ADDITIONAL_SERVICES: '전체 부가서비스 보기',
  ALL_ADDITIONAL_SERVICES: '전체 부가서비스',

  KB_BRIDGE_APP_DOWNLOAD: 'KB브릿지 APP 다운받기',
  KB_BRIDGE_APP_DOWNLOAD_GUIDE: '휴대폰 카메라 또는 QR코드 리더 앱을 통해 아래 QR코드를 스캔해주세요.',
});
